export default __webpack_public_path__ + "static/media/RIVIERA.5818244c.jpg";